import { Filter, FilterType } from '@dfl/mui-admin-layout';
import { TermFilter } from '@dofleini/query-builder';
import { createdATFilter } from 'modules/common/constants';
import { PROVIDER_DATA_TYPE_ENUM } from '../interfaces/IProviderField';
import { PROVIDER_TYPE_ENUM } from 'modules/inventory/provider/common/constants/provider.types';

export const providerTypeFilter: Filter = {
  filter: 'providerField:fields.providerType',
  type: FilterType.FIXED_LIST,
  translate: true,
  key: 'provider_type',
  field: 'providerType',
  transform: (value: PROVIDER_TYPE_ENUM) => new TermFilter({ field: 'providerType', value }),
  options: [PROVIDER_TYPE_ENUM.SUPPLIER, PROVIDER_TYPE_ENUM.LOGISTIC].map((v) => ({
    value: v,
    translate: true,
    label: `providerField:PROVIDER_TYPE.${v}`,
  })),
};

export const providerDataTypeFilter: Filter = {
  filter: 'providerField:fields.dataType',
  type: FilterType.FIXED_LIST,
  translate: true,
  key: 'data_type',
  field: 'dataType',
  transform: (value: PROVIDER_DATA_TYPE_ENUM) => new TermFilter({ field: 'dataType', value }),
  options: Object.values(PROVIDER_DATA_TYPE_ENUM).map((v) => ({
    value: v,
    translate: true,
    label: `providerField:DATA_TYPE.${v}`,
  })),
};

export const providerFieldFilters = [providerTypeFilter, providerDataTypeFilter, createdATFilter];
